import { observable, set, computed } from 'mobx';
import {
    IContentObjListItem,
    IArticleObjItem,
    ISubAttributes
} from '../../interfaces/ISearchInterfaces';
import { RESULT_TYPE } from '../../constants/Search';

export interface ISearchArticleCatalog {
    contentObjListItems: IContentObjListItem[];
}

export class SearchArticleCatalog {
    @observable private contentItems: IContentObjListItem[] = [];
    @observable private articleItems: IArticleObjItem[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static fromJSON(data: any): SearchArticleCatalog {
        const searchArticleCatalog = new SearchArticleCatalog();
        set(searchArticleCatalog, data);

        return searchArticleCatalog;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public update = (data: any) => {
        set(this, data);
        this.contentItems = [];
        this.articleItems = [];

        const catalog: ISearchArticleCatalog = {
            contentObjListItems: data.contentObjListItems
        };

        if (catalog.contentObjListItems.length) {
            this.contentItems = catalog.contentObjListItems;

            this.contentItems.forEach((contentObjListItem) => {
                switch (contentObjListItem.type) {
                    case RESULT_TYPE.ARTICLE:
                        if (this.isArticleValid(contentObjListItem.articles[0].attributes)) {
                            const article = this.createArticle(contentObjListItem);
                            this.articleItems.push(article);
                        }
                        break;

                    default:
                }
            });
        }
    };

    private isArticleValid(articleAttributes: ISubAttributes): boolean {
        let isValid = false;

        if (
            articleAttributes.c_template_title &&
            articleAttributes.c_uri &&
            articleAttributes.c_url_alias
        ) {
            isValid = true;
        }

        return isValid;
    }

    private createArticle(articleItem: IContentObjListItem): IArticleObjItem {
        const {
            c_meta_og_description = '',
            c_template_title,
            c_uri,
            c_url_alias
        } = articleItem.articles[0].attributes;

        const article: IArticleObjItem = {
            nId: articleItem.nId,
            templateTitle: c_template_title[0],
            uri: c_uri[0],
            urlAlias: c_url_alias[0],
            // @todo This is a temporary mapping. Needs to be updated after DRUPALPLAT-5595 is done
            shortDescription: c_meta_og_description[0]
        };

        return article;
    }

    @computed
    public get content() {
        return this.contentItems;
    }

    @computed
    public get articles() {
        return this.articleItems;
    }

    @computed
    public get numContentRecs() {
        return {
            articlesRecNumber: this.articleItems.length
        };
    }
}
